"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const BlockAcceptEsign = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("rect", { width: 24, height: 18, y: 3, fill: "#00857B", rx: 2 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M4.667 16c0-.368.298-.667.666-.667h13.334a.667.667 0 0 1 0 1.334H5.333A.667.667 0 0 1 4.667 16Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M8.496 6.502c-.265-.041-.563.002-.9.184-.725.39-1.12.945-1.287 1.57-.17.64-.108 1.389.159 2.151.311.887.88 1.739 1.593 2.393a5.404 5.404 0 0 1 3.02-1.787 10.59 10.59 0 0 0-.34-1.553c-.346-1.142-.852-2.037-1.419-2.535-.278-.245-.555-.381-.826-.423Zm3.58 4.409a11.607 11.607 0 0 0-.378-1.74c-.373-1.232-.953-2.327-1.715-2.997-.387-.34-.834-.583-1.334-.66-.504-.078-1.021.019-1.528.292-.965.52-1.54 1.299-1.779 2.193-.234.881-.133 1.84.182 2.739a7.052 7.052 0 0 0 1.954 2.882 6.157 6.157 0 0 0-.264.5 6.248 6.248 0 0 0-.608 2.682c.008.817.207 1.582.615 2.098.208.264.482.475.82.57.34.095.699.06 1.05-.088.676-.285 1.352-.997 2.008-2.132.886-1.529 1.187-3.48 1.078-5.338l.093.005c.431.026.75.134.932.258.172.118.23.223.258.307.035.104.039.222.035.41l-.001.043c-.005.157-.012.41.068.64.107.314.344.537.694.663.473.172.861-.066 1.101-.289.236-.22.448-.53.623-.789l.018-.027c.184-.27.34-.501.5-.672.095-.1.164-.15.211-.175a.945.945 0 0 1 .019.06 3.3 3.3 0 0 1 .074.368l.013.083c.019.12.04.257.066.384.033.155.08.337.166.501.087.168.236.36.49.454.25.092.506.051.73-.037.221-.087.457-.239.712-.441a.5.5 0 1 0-.624-.782c-.209.167-.353.25-.445.289a1.474 1.474 0 0 1-.05-.188c-.02-.1-.037-.204-.055-.323l-.016-.098a4.241 4.241 0 0 0-.1-.484 1.336 1.336 0 0 0-.253-.509.844.844 0 0 0-.654-.3c-.448 0-.785.272-1.012.513-.217.231-.415.524-.582.77l-.036.053c-.19.281-.339.49-.476.618a.477.477 0 0 1-.097.074.234.234 0 0 1-.07-.037l-.002-.004c-.015-.045-.017-.114-.012-.335.004-.183.01-.46-.085-.747-.101-.306-.303-.585-.644-.818-.38-.26-.892-.398-1.435-.431a4.326 4.326 0 0 0-.254-.008Zm2.52 2.387Zm3.24-.11Zm-6.655-1.174a4.398 4.398 0 0 0-2.323 1.393c.307.191.63.344.961.45a.5.5 0 0 1-.305.953 5.361 5.361 0 0 1-1.232-.583 5.248 5.248 0 0 0-.676 2.565c.007.69.178 1.209.4 1.488a.61.61 0 0 0 .305.227c.091.025.217.027.392-.046.373-.157.91-.638 1.53-1.711.762-1.316 1.04-3.052.948-4.736Z"
      }
    )
  );
};
export default BlockAcceptEsign;
